import { LoiComparisonFormDto } from './models/loi-comparison-form.model';

export async function fetchLoiComparison(
    axios: { get: (url: string) => Promise<{ data: LoiComparisonFormDto[]; status: number }> },
    engagementId: number
): Promise<LoiComparisonFormDto[]> {
    const response = await axios.get(
        `/api/Marketplace/${engagementId}/LoiComparison`
    );
    if (response.status !== 200) {
        throw new Error('Failed to fetch LOI comparison');
    }
    return response.data as LoiComparisonFormDto[];
}
